import axios from '@/utils/request'
var Qs = require('qs')

export default {
	workflowStates: ['undo', 'done', 'canceled', 'giveUp'],
	// 2021-09-23
	findByDateAndShop(params) {
		return axios.get('/weddingDressHall/schedule/find-by-date-and-shop', params);
	},

	// 2022-01-05
	findScheduleByDate(params) {
		return axios.get('/weddingDressHall/schedule/find-schedule-by-date', params);
	},
	// 2022-01-08
	search(params) {
		return axios.get('/weddingDressHall/schedule', params);
	},

	// 2021-09-23
	exportExcel(params) {
		return axios.get('/weddingDressHall/schedule/export-excel', params)
	},
	// 2021-09-23
	create(params) {
		return axios.post('/weddingDressHall/schedule', params);
	},
	// 2021-10-15
	addSpecialDay(params) {
		return axios.post('/weddingDressHall/schedule/add-special-day', params);
	},
	//  2020-09-23
	update(id, params) {
		return axios.put('/weddingDressHall/schedule/' + id, params)
	},
	//  2020-09-23
	delete(id) {
		return axios.delete('/weddingDressHall/schedule/' + id)
	},
	//  2020-09-23
	cancel(id) {
		return axios.put('/weddingDressHall/schedule/' + id + '/cancel')
	},
	// 2020-09-23
	finish(id) {
		return axios.put('/weddingDressHall/schedule/' + id + '/finish')
	},
	// 2020-09-23
	giveUp(id) {
		return axios.put('/weddingDressHall/schedule/' + id + '/give-up')
	},
	// 2020-10-11
	todaySchedule() {
		return axios.get('/weddingDressHall/schedule/today-schedule')
	},
	// 2021-10-21
	updateCustomer(id, params) {
		return axios.put('/weddingDressHall/schedule/' + id + '/update-customer', params)
	},

	// 2021-11-05
	vagueFindTitle(params) {
		return axios.get('/weddingDressHall/schedule/vague-find-title', params)
	},

	// 2020-09-23
	findById(id) {
		return axios.get('/weddingDressHall/schedule/' + id)
	}
}

